import React from 'react';

import {
    Modal,
    Button,
    Input,
} from 'antd'

class EmailModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            message: '',
        }
    }

    render() {

        const {bug} = this.props;

        return(
            <Modal
                onOk={() => this.props.handleSendEmail(this.state.message)}
                afterClose={this.props.afterClose}
                onCancel={this.props.onCancel}
                title="Send an Email to the user"
                closable={false}
                centered
                visible={true}
                width={'70%'}
                // okButtonProps={{
                //     loading,
                //     disabled: !this.state.reassignReason
                // }}
            >   
                <div style={{backgroundColor: '#e8e8e8', padding: '25px 50px'}}>
                    <div style={{backgroundColor: 'white', padding: '30px 60px', borderRadius: '5px'}}>
                        <p>Dear {bug.createdBy.name},</p>
                        <p>{`Thank you for reaching out to Eezee Support. My name is ${bug.agent.name}, and I am happy to help you with this today.`}</p>
                        <p>{this.state.message}</p>
                        <p>{`If I can be of any further assistance, please don't hesitate to reply directly to this email and reference case number ${bug.refNumber}. I am always happy to help.`}</p>
                        <p>Best Regards,</p>
                        <p>{bug.agent.name}</p>
                   </div>
                </div>
                <Input.TextArea
                    rows={2}
                    placeholder="Message"
                    onChange={(e)=>this.setState({message: e.target.value})}
                    style={{width: '100%'}}
                />
            </Modal>
        )
    }

    
}

export default EmailModal;


// WEBPACK FOOTER //
// ./src/components/bug-report/email-modal.js